<app-menu class="menuApp"></app-menu>
<div class="mainLocations">
  <div class="row heightRow">

    <div style="width: 100%" *ngIf="proyectoService.getSelectALocation() && user.getProyectos().length > 0">
      <div class="middleText">
        <h3 class="textM centerVert">{{localiser.get('location.selectALocation')}}</h3>
      </div>
    </div>

    <div *ngFor="let proyecto of user.getProyectos(); index as i" class="backLocationRow">
      <div class="row centerVert locationRow">
        <div class="col-4 text-center" style="padding: 3px">
          <div class="row insideRowPlace">
            <div class="row locationName" (click)="toLastPage(proyecto)">
              <div class="col-4 marginAuto">
                <span class="material-icons-outlined marginAuto textL+">place</span>
              </div>

              <div class="col-8">
                <h1 class="centerVert padding-zero text-center textXM">{{proyecto.nombre}}</h1>
              </div>

            </div>

            <div class="row insideRowButtons">
              <div (click)="toFloorplans(proyecto)" class="col-4 buttonLeft">
                <span class="material-icons-outlined centerVert marginAuto textL+">layers</span>
              </div>
              <div *ngIf="user.getPermiso() != 'Ateneo'" (click)="toDevices(proyecto)" class="col-4 buttonCenter">
                <span class="material-icons-outlined centerVert marginAuto textL+">info</span>
              </div>

              <div *ngIf="user.getPermiso() == 'Ateneo'" (click)="toIndicators(proyecto)" class="col-4 buttonCenter">
                <span class="material-icons-outlined centerVert marginAuto textL+">equalizer</span>
              </div>
              <div *ngIf="user.getPermiso() != 'Ateneo'" (click)="toAlerts(proyecto)" class="col-4 buttonRight">
                <span class="material-icons-outlined centerVert marginAuto textL+">warning_amber</span>
              </div>
              <div *ngIf="user.getPermiso() == 'Ateneo'" (click)="toAteneoZones(proyecto)" class="col-4 buttonRight">
                <span class="material-icons-outlined centerVert marginAuto textL+">smart_button</span>
              </div>
            </div>
            </div>
        </div>
        <div (click)="toIndicators(proyecto)" class="col-8" style="cursor: pointer; padding: 3px 18px 3px 12px;">
          <div class="row maxHeight" style="background: white; border-radius: 0 17px 17px 0;">
            <div *ngIf="simpleInfoIsReady(proyecto.idProyecto) && hasProjectData(proyecto.idProyecto)" class="col marginAuto">
              <div class="row">
                <h1 *ngIf="showSimpleInfo(proyecto.idProyecto, 0, true) != undefined" class="text-center marginAuto textS+ dataColList">{{localiser.get('location.' + showSimpleInfo(proyecto.idProyecto, 0, true))}}</h1>
              </div>
              <div class="row">
                <h1 *ngIf="showSimpleInfo(proyecto.idProyecto, 0, false) != undefined" class="text-center marginAuto textXM textDataList">{{showSimpleInfo(proyecto.idProyecto, 0, false)}}</h1>
              </div>
            </div>
            <div *ngIf="simpleInfoIsReady(proyecto.idProyecto) && hasProjectData(proyecto.idProyecto)" class="col marginAuto">
              <div class="row">
                <h1 *ngIf="showSimpleInfo(proyecto.idProyecto, 1, true) != undefined" class="text-center marginAuto textS+ dataColList">{{localiser.get('location.' + showSimpleInfo(proyecto.idProyecto, 1, true))}}</h1>
              </div>
              <div class="row">
                <h1 *ngIf="showSimpleInfo(proyecto.idProyecto, 1, false) != undefined"  class="text-center marginAuto textXM textDataList">{{showSimpleInfo(proyecto.idProyecto, 1, false)}}</h1>
              </div>
            </div>
            <div *ngIf="simpleInfoIsReady(proyecto.idProyecto) && !hasProjectData(proyecto.idProyecto)" class="col marginAuto">
              <div class="row">
                <h3 class="text-center marginAuto textM" style="color: #999;">{{localiser.get('location.noData')}}</h3>
              </div>
            </div>
            <div *ngIf="!simpleInfoIsReady(proyecto.idProyecto)" class="col marginAuto">
              <div class="row">
                <mat-progress-spinner class="marginAuto" color="primary" mode="indeterminate" diameter="60">
                </mat-progress-spinner>
              </div>
            </div>

            <div class="col-3">
              <span class="material-icons-outlined centerVert marginAuto locationsIconSize colorListIcon">equalizer</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%" *ngIf="user.getProyectos().length <= 0">
      <div class="middleText">
        <h3 class="textM centerVert">{{localiser.get('location.noProjects')}}</h3>
      </div>
    </div>

  </div>
</div>
